import "core-js/modules/es.array.find-index.js";
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "home-jiao"
};
var _hoisted_2 = {
  class: "tab"
};
var _hoisted_3 = {
  class: "jiao-content"
};
import { ChevronRightDoubleIcon } from 'tdesign-icons-vue-next';
import NavTab from '../Components/NavTab.vue';
import Interact from './Interact/index.vue';
import Data from './Data/index.vue';
import Teaching from './Teaching/index.vue';
import { computed, ref, onMounted, onUnmounted } from 'vue';
import { env_name } from '@/util/util.js';
import WujieVue from 'wujie-vue3';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var bus = WujieVue.bus;
    var tabs = [{
      name: '课堂互动',
      value: 1,
      component: Interact,
      exist: true
    }, {
      name: '课堂数据',
      value: 2,
      component: Data,
      exist: true
    }, {
      name: '远程教学',
      value: 3,
      component: Teaching,
      exist: false
    }];
    var defaultIndex = ref(1);
    var currentComponent = computed(function () {
      var index = tabs.findIndex(function (item) {
        return item.value === defaultIndex.value;
      });
      return tabs[index].component;
    });
    var handleChangeTab = function handleChangeTab(item) {
      defaultIndex.value = item.value;
    };

    // 查看更多
    var toClassReport = function toClassReport() {
      var commonName = env_name ? "//".concat(env_name, "web.zhixuehuijiao.cn") : '//web.zhixuehuijiao.cn';
      window.open("".concat(commonName, "/classReports?classReports=%2Freport"));
    };
    var showAppbtn = ref(false);
    onMounted(function () {
      bus.$on('show-enter-class-report', function (val) {
        showAppbtn.value = val;
      });
    });
    onUnmounted(function () {
      bus.$off('show-enter-class-report');
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(NavTab, {
        tabs: tabs,
        "default-index": defaultIndex.value,
        onChange: handleChangeTab
      }, null, 8, ["default-index"]), showAppbtn.value && defaultIndex.value === 1 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "look-more",
        onClick: toClassReport
      }, [_cache[0] || (_cache[0] = _createTextVNode(" 查看更多 ", -1)), _createVNode(_unref(ChevronRightDoubleIcon))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_3, [(_openBlock(), _createBlock(_resolveDynamicComponent(currentComponent.value)))])]);
    };
  }
};